import { useState } from 'react'
import { Form, OverlayTrigger, Table, Tooltip } from 'react-bootstrap'
import { CloudArrowDownFill, Search } from 'react-bootstrap-icons'
import { toast } from 'react-toastify'
import { CustomButton } from '../../components/CustomButton'
import Navbar from '../../components/navbar/navbar'
import { useOrdenation } from '../../hooks/useOrdenation'
import apinode from '../../services/apinode'
import ProdutosService from '../../services/database/ProdutosService'
import { formatPrice } from '../../utils/formatPrice'
import { sendErrorApiMessage } from '../../utils/sendErrorApiMessage'
import { Center, CenterContent } from './styles'

export function ImportarProdutos() {
  const [products, setProducts] = useState([])
  const [isSearching, setIsSearching] = useState(false)
  const [search, setSearch] = useState('')
  const [isImporting, setIsImporting] = useState({})

  const { filteredItems, Th, Paginate } = useOrdenation(products, 'SKU')

  const isMatriz =
    localStorage.idconta === process.env.REACT_APP_DATABASE_MATRIZ

  async function handleSearch() {
    try {
      setIsSearching(true)

      const response = await apinode.get(
        `/produtos/${process.env.REACT_APP_DATABASE_MATRIZ}?search=${search}`,
      )

      setProducts(response.data)
    } catch (err) {
      sendErrorApiMessage(err, 'Não foi possível encontrar o produto')
    } finally {
      setIsSearching(false)
    }
  }

  async function handleImport(sku, index) {
    try {
      setIsImporting((prevState) => ({
        ...prevState,
        [index]: true,
      }))

      const codproduto = await ProdutosService.importProduct(sku)

      toast.success(`Produto foi importado com o ID: ${codproduto}`)
    } catch (err) {
      sendErrorApiMessage(err, 'Erro ao importar o produto')
    } finally {
      setIsImporting((prevState) => ({
        ...prevState,
        [index]: false,
      }))
    }
  }

  return (
    <div className="mt-page">
      <Navbar />

      <CenterContent>
        <CloudArrowDownFill size={80} />

        <h1>
          {isMatriz
            ? 'Indisponível para essa base de dados!'
            : 'Importar Produtos da Matriz'}
        </h1>

        {!isMatriz && (
          <>
            <Center>
              <Form.Control
                disabled={isMatriz}
                placeholder="Digite o SKU ou Descrição"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    if (search) {
                      handleSearch()
                    }
                  }
                }}
              />

              <CustomButton
                isDisabled={!search}
                title="Buscar"
                onClick={handleSearch}
                isLoading={isSearching}
                isLoadingText="Buscando..."
              >
                <Search size={18} />
              </CustomButton>
            </Center>

            {filteredItems.length > 0 && (
              <>
                <Table>
                  <thead>
                    <tr>
                      <Th
                        value="SKU"
                        label="SKU"
                      />

                      <Th
                        value="DESCRICAO"
                        label="Descrição"
                      />

                      <Th
                        value="PRECOVENDA"
                        label="Preço Venda"
                      />

                      <th>Ação</th>
                    </tr>
                  </thead>

                  <tbody>
                    {filteredItems.map((product, index) => (
                      <tr>
                        <td>{product.SKU}</td>
                        <td>{product.DESCRICAO}</td>
                        <td>{formatPrice(product.PRECOVENDA)}</td>
                        <td>
                          <OverlayTrigger overlay={<Tooltip>Importar</Tooltip>}>
                            <CustomButton
                              onClick={() => handleImport(product.SKU, index)}
                              isLoading={isImporting[index]}
                            >
                              <CloudArrowDownFill />
                            </CustomButton>
                          </OverlayTrigger>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>

                <Paginate />
              </>
            )}
          </>
        )}
      </CenterContent>
    </div>
  )
}
